import { Navigate, Route, Routes } from "react-router-dom";
import { PageTitle } from "../../../_start/layout/core";
import { CreateDepartment } from "./pages/department/CreateDepartment";
import { DepartmentsPage } from "./pages/department/DepartmentsPage";
import { UpdateDepartment } from "./pages/department/UpdateDepartment";
import { CreateEmployee } from "./pages/employee/CreateEmployee";
import { EmployeesPage } from "./pages/employee/EmployeesPage";
import { UpdateEmployee } from "./pages/employee/UpdateEmployee";

export const EmployeeManagementPage = () => {
	return (
		<Routes>
			{/* begin::Employee Routes */}
			<Route
				path="employees"
				element={
					<>
						<PageTitle>Personeel</PageTitle>
						<EmployeesPage />
					</>
				}
			/>
			<Route
				path="employees/create"
				element={
					<>
						<PageTitle>Personeel</PageTitle>
						<CreateEmployee />
					</>
				}
			/>
			<Route
				path="employees/:id/update"
				element={
					<>
						<PageTitle>Personeel</PageTitle>
						<UpdateEmployee />
					</>
				}
			/>
			{/* end::Employee Routes */}

			{/* begin::Employee Routes */}
			<Route
				path="departments"
				element={
					<>
						<PageTitle>Afdelingen</PageTitle>
						<DepartmentsPage />
					</>
				}
			/>
			<Route
				path="departments/create"
				element={
					<>
						<PageTitle>Afdelingen</PageTitle>
						<CreateDepartment />
					</>
				}
			/>
			<Route
				path="departments/:id/update"
				element={
					<>
						<PageTitle>Afdelingen</PageTitle>
						<UpdateDepartment />
					</>
				}
			/>
			{/* end::Employee Routes */}

			<Route
				index
				element={<Navigate to="/employee-management/employees" replace />}
			/>
			<Route
				path="*"
				element={<Navigate to="/employee-management/employees" replace />}
			/>
		</Routes>
	);
};
